import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MogoConfirmTransactionService } from 'src/app/public-website/buyer/services/mogo-confirm-transaction.service';
import { MogoSelectPlanService } from 'src/app/public-website/buyer/services/mogo-select-plan.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mogo',
  templateUrl: './mogo.component.html',
  styleUrls: ['./mogo.component.scss'],
})
export class MogoComponent implements OnInit {
  mogoInstallments = [];
  sendCodeClicked: boolean = true;
  sendFailed: string;
  nextStep: boolean = true;
  data: Data;
  otpTimesCount: number;
  remainingTime: number;

  constructor(
    private _formBuilder: FormBuilder,
    private selectPlan: MogoSelectPlanService,
    private confirmTransaction: MogoConfirmTransactionService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  mogoOption = this._formBuilder.group({
    option: ['', [Validators.required]],
  });

  mogoOtp = this._formBuilder.group({
    otp: ['', [Validators.required, Validators.pattern(/^(.{5}$|$)/g)]],
  });

  ngOnInit(): void {
    this.data = JSON.parse(localStorage.getItem('mogoData'));
    localStorage.removeItem('mogoData');
    this.mogoInstallments = this.data.installmentPlans;
  }

  async sendOTP() {
    try {
      let optionChoose = {
        transactionId: this.data.transactionId,
        refNumber: this.data.refNum,
        planId: this.mogoOption.controls['option'].value,
      };
      this.selectPlan.setParams(optionChoose);
      await this.selectPlan.make();

      this.nextStep = false;
      this.sendCodeClicked = false;
    } catch (e) {
      console.log(e);
      const msg = e?.faultyRequest?.error?.message;
      if (msg) {
        this.sendFailed = msg;
      } else {
        this.sendFailed = 'Unexpected Error';
      }
    }
  }

  async resendOTP() {
    try {
      let optionChoose = {
        transactionId: this.data.transactionId,
        refNumber: this.data.refNum,
        planId: this.mogoOption.controls['option'].value,
      };
      this.selectPlan.setParams(optionChoose);
      const res = await this.selectPlan.make();
      if (res.success) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'OTP',
          text: `The remaining time to get a new OTP is ${res.data.remainingTime}s and the remaining tries are ${res.data.otpTimesCount}`,
        });
      }
    } catch (e) {
      console.log(e);
      const msg = e?.faultyRequest?.error?.message;
      if (msg) {
        this.sendFailed = msg;
      } else {
        this.sendFailed = 'Unexpected Error';
      }
    }
  }

  async payment() {
    try {
      let paymentBody = {
        transactionId: this.data.transactionId,
        otp: this.mogoOtp.controls['otp'].value,
        refNumber: this.data.refNum,
      };
      this.confirmTransaction.setParams(paymentBody);
      const res = await this.confirmTransaction.make();
      if (res.success === true) {
        const url = localStorage.getItem('customerRedirectUrl');
        await Swal.fire({
          position: 'center',
          icon: 'success',
          text: this.translate.instant('PROVIDER.CREDIT.MESSAGESUCCESS'),
          showConfirmButton: false,
          showCancelButton: true,
        }).then((result) => {
          if (url) {
            const customerRedirectUrl = new URL(url);
            customerRedirectUrl.searchParams.set('status', 'success');
            customerRedirectUrl.searchParams.set(
              'providerRefNum',
              this.data.refNum,
            );
            customerRedirectUrl.searchParams.set(
              'customerReference',
              res.data.customerReference,
            );
            window.location.href = customerRedirectUrl.toString();
            return;
          }
          this.router.navigate(['/']);
        });
      }
    } catch (err) {
      console.log(err);
      const msg = err?.faultyRequest?.error?.message;
      if (msg) {
        this.sendFailed = msg;
      } else {
        this.sendFailed = 'Unexpected Error';
      }
    }
  }
}

type Data = {
  totalAmount: number;
  downPayment: number;
  merchantName: string;
  transactionId: string;
  installmentPlans: InstallmentPlans[];
  refNum: string;
};

type InstallmentPlans = {
  planId: string;
  months: number;
  installment: number;
  adminFees: number;
};
